/*
 * @Author: wyh
 * @Date: 2019-08-05 16:19:33
 * @Last Modified by: wyh
 * @Last Modified time: 2019-08-07 15:43:22
 * @Description: 登录接口服务
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import {
  StorageService,
  EventService,
  RequestService,
  LoadingService,
  GlobalState,
  CreateImage,
  imgOptions,
  LoggerService,
} from "../../common";
import { EncryptionSerProvider } from "../../common/encryption";
import { Device } from "@ionic-native/device";
import { APP_PLATFORM_THIRD, INVARIANT } from "../../../config";
import { CacheDataService } from "../cache-data/cache-data.service";
import { NewsService } from "../news/news.service";

class LoginModal {
  username: string;
  password: string;
  canvas: any;
}

@Injectable()
export class LoginService {
  constructor(
    private encySer: EncryptionSerProvider,
    private device: Device,
    private storageSer: StorageService,
    private eventSer: EventService,
    private requestSer: RequestService,
    private cachedataSer: CacheDataService,
    private loaderSer: LoadingService,
    private global: GlobalState,
    private newsSer: NewsService,
    private logger: LoggerService,
  ) {}

  /**
   * 登录
   * @param data
   */
  doLogin(data: LoginModal): Observable<any> {
    console.log("doLogin");
    console.log(data);
    const { username, password, canvas = false } = data;
    const params = {
      deviceAppUUID: this.device.uuid || "0",
      username: username,
      password: password,
    };
    console.log(params);
    return Observable.create((observe) => {
      this.requestSer.httpRequestForLogin("LOGIN", params, false).subscribe(
        (res) => {
          console.log(res);
          const { datas, code } = res;
          if (code != "200") return observe.error(res);
          observe.next("step2");
          /** 系统数据在app启动时初始化失败 登录时再次初始化 初始化成功才能登录 */
          const errRes = { code: "errUser", err: res };
          this.global.set("userInfo", datas);
          if (!this.global.state.initSystem) {
            this.cachedataSer.cacheSysDatas().then(
              (cacheSys) => {
                console.log(cacheSys);
                this.global.set("initSystem", true);
                this.initUserAbout(datas, canvas).then(
                  (initResult) => observe.next(res),
                  (err) => observe.error(errRes),
                );
              },
              (err) => {
                console.error("something is cache error", err);
                errRes.code = "errSys";
                return observe.error(errRes);
              },
            );
          } else {
            this.initUserAbout(datas, canvas).then(
              (initResult) => observe.next(res),
              (err) => observe.error(errRes),
            );
          }
        },
        (error) => {
          console.error(error);
          observe.error({ code: false, error });
        },
      );
    });
  }

  /**
   * 第三方集成登录 不初始化首页 无法进入首页
   * @param loginParams
   */
  IAMLogin(loginParams): Observable<any> {
    console.log(loginParams);
    const canvas = document.getElementById("canvas");
    return Observable.create((observe) => {
      this.requestSer.httpRequestForLogin("LOGIN", loginParams).subscribe(
        (res) => {
          console.log(res);
          const { datas, code } = res;
          if (code != "200") return observe.error(res);
          /** 系统数据在app启动时初始化失败 登录时再次初始化 初始化成功才能登录 */
          const errRes = { code: "errUser", err: res };
          this.global.set("userInfo", datas);
          if (!this.global.state.initSystem) {
            this.cachedataSer.cacheSysDatas().then(
              (cacheSys) => {
                console.log(cacheSys);
                this.global.set("initSystem", true);
                this.initUserAbout(datas, canvas).then(
                  (initResult) => observe.next(res),
                  (err) => observe.error(errRes),
                );
              },
              (err) => {
                console.error("something is cache error", err);
                errRes.code = "errSys";
                return observe.error(errRes);
              },
            );
          } else {
            this.initUserAbout(datas, canvas).then(
              (initResult) => observe.next(res),
              (err) => observe.error(errRes),
            );
          }
        },
        (error) => {
          console.error(error);
          observe.error({ code: false, error });
        },
      );
    });
  }

  /**
   * 使用密码登录
   * @param data
   */
  usePsdLogin(data: LoginModal): Observable<any> {
    console.log("usePsdLogin");
    console.log(data);
    const { username, password } = data;
    const params = {
      deviceAppUUID: this.device.uuid || "0",
      username: username,
      password: password,
    };
    return new Observable((observe) => {
      this.requestSer.httpRequestForLogin("LOGIN", params, false).subscribe(
        (res) => {
          console.log(res);
          const { datas, code } = res;
          if (code != "200") return observe.error(res);
          datas["userHeaderUrl"] = this.global.state.userInfo.userHeaderUrl;
          console.log(datas); //关注userHeaderUrl是否存在
          this.storageSer.setStore(INVARIANT._USER_USERINFO, datas);
          this.global.set("userInfo", datas);
        },
        (error) => {
          console.error(error);
          observe.error({ code: false, error });
        },
      );
    });
  }

  /**
   * 第三方集成登录 不初始化首页 无法进入首页
   * @param loginParams
   */
  thirdPltLogin(loginParams): Observable<any> {
    console.log(loginParams);
    return Observable.create((observe) => {
      this.requestSer.httpRequestForLogin("LOGIN", loginParams).subscribe(
        (res) => {
          const { datas, code } = res;
          if (code != "200") return observe.error(res);
          /** 系统数据在app启动时初始化失败 登录时再次初始化 初始化成功才能登录 */
          const errRes = { code: "errUser", err: res };
          this.global.set("userInfo", datas);

          if (!this.global.state.initSystem) {
            this.cachedataSer.cacheSysDatas().then(
              (cacheSys) => {
                this.global.set("initSystem", true);
                this.storageSer.setStore(INVARIANT._USER_USERINFO, datas);
                this.initUserAbout(datas, false).then(
                  (initResult) => observe.next(res),
                  (err) => observe.error(errRes),
                );
              },
              (err) => {
                console.error("something is cache error", err);
                errRes.code = "errSys";
                return observe.error(errRes);
              },
            );
          } else {
            this.initUserAbout(datas, false).then(
              (initResult) => observe.next(res),
              (err) => observe.error(errRes),
            );
            this.storageSer.setStore(INVARIANT._USER_USERINFO, datas);
            observe.next(res);
          }
        },
        (error) => {
          console.error(error);
          observe.error({ code: false, error });
        },
      );
    });
  }

  /** 初始化用户相关信息 */
  initUserAbout(userinfo, canvas?): Promise<any> {
    const { userHeaderUrl, userName, id } = userinfo;
    if (!userHeaderUrl && canvas) {
      //如果用户头像不存在则使用用户姓名生成一个
      const heardUrl = this.createImg(canvas, userName);
      userinfo["userHeaderUrl"] = heardUrl;
    }
    return new Promise((resolve, reject) => {
      const checkProArr = [
        this.cachedataSer.initHomeTem(id), //初始化主页
      ];
      Promise.all(checkProArr).then(
        (resultProArr) => {
          console.log(resultProArr);
          this.storageSer.setStore(INVARIANT._USER_USERINFO, userinfo);
          this.global.set("userInfo", userinfo);
          !APP_PLATFORM_THIRD && this.newsSer.startTimeer(); //启动定时获取推送
          resolve(resultProArr);
        },
        (err) => {
          console.error("something is cache error", err);
          return reject(err);
        },
      );
    });
  }

  /**
   * 生成文字头像图片
   * @param canvas 用于绘制图片的dom元素
   * @param userName 用于绘制图片的文字
   */
  createImg(canvas, userName) {
    const createImage = new CreateImage();
    const imgOption = new imgOptions();
    imgOption.canvas = canvas;
    const reg = /^[\x00-\xFF]/; //判断是否为英文
    if (reg.test(userName)) {
      imgOption.text = userName.substr(0, 1);
      imgOption.offsetX = 10;
    } else {
      imgOption.text = userName.substr(-1);
    }
    return createImage.cheateImg(imgOption);
  }

  /**
   * 退出登录
   */
  async exitLogin(): Promise<any> {
    return new Promise((resolve) => {
      this.requestSer.httpRequest("LOGINOUT").subscribe(
        (res) => {
          console.log(res);
          //退出登录不管是否清除成功都要登出
          this.deleteLoginInfo().then((delRes) => resolve(true));
        },
        (err) => {
          this.logger.error("loginOut-error -- ", err);
          this.deleteLoginInfo().then((delRes) => resolve(true));
          resolve(false);
        },
      );
    });
  }

  /**
   * 删除用户相关登录信息
   */
  deleteLoginInfo(): Promise<any> {
    const promiseDel = [];
    return new Promise((resolve) => {
      try {
        for (const key in INVARIANT) {
          if (key.includes(INVARIANT._USEFLAG)) {
            const userkey =
              key === "_USER_USERINFO"
                ? INVARIANT[key]
                : this.global.state.userInfo[INVARIANT._USERID] +
                  INVARIANT[key];
            this.storageSer.removeStore(userkey);
          }
        }
        resolve(true);
      } catch (error) {
        console.log(error);
        return resolve(false);
      }
    });
  }

  /**
   * 修改用户角色
   * @param role
   */
  changeUserRole(role, headerUrl): Observable<any> {
    this.logger.log("修改用户角色。。。");
    this.logger.log(role);
    return new Observable((observe) => {
      this.requestSer.httpRequest("CHANGEUSERROLE", role).subscribe(
        (res) => {
          if (res && res.code == "200") {
            this.cachedataSer.initHomeTem(res.datas.id).then(
              (_) => {
                res.datas["userHeaderUrl"] = headerUrl;
                this.storageSer.setStore(INVARIANT._USER_USERINFO, res.datas);
                observe.next(res);
                observe.complete();
              },
              (err) => {
                //首页入口重新加载失败
                res.returnMessage = false;
                observe.error(res);
              },
            );
          } else {
            observe.error(res);
          }
        },
        (err) => {
          observe.error(false);
        },
      );
    });
  }

  /**
   * 获取系统参数
   * @param systypeCode
   */
  findAdSysParamsByCode(systypeCode): Observable<any> {
    const param = {
      paramCode: systypeCode,
      typeCode: "IAM_SERVICE_PARAM",
    };
    return new Observable((observe) => {
      this.requestSer.httpRequest("IMAGE_PORT", param).subscribe(
        (res) => {
          if (res && res.code == "200" && res.datas.paramValues) {
            window.location.href = res.datas.paramValues;
          } else {
            observe.error(res);
          }
        },
        (err) => {
          observe.error(false);
        },
      );
    });
  }

  /**
   * 获取用户名密码
   * @param role
   */
  getUserAccount(param): Observable<any> {
    return new Observable((observe) => {
      this.requestSer.httpRequest("SYS_SECURITY_CHECKBYIAM", param).subscribe(
        (res) => {
          if (res && res.code == "200") {
            observe.next({ datas: res.datas });
            observe.complete();
          } else {
            observe.error(res);
          }
        },
        (err) => {
          observe.error(false);
        },
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/business/login/login.service.ts